import { useEffect } from "react";
import { ArrowUpRight } from "lucide-react";
import Navbar from "@/components/site/Navbar";
import Footer, { FooterCta, ChatBubble } from "@/components/site/Footer";
import Reveal from "@/components/site/Reveal";
import LightArc from "@/components/site/LightArc";
import { SiteProvider, useSite } from "@/context/SiteContext";
import { trackVisit } from "@/lib/api";

function About() {
  const { content, openBooking } = useSite();
  const about = content.about || {};

  useEffect(() => { trackVisit(); }, []);

  return (
    <div className="bg-[#0A1628] min-h-screen">
      <Navbar />

      <section className="relative overflow-hidden bg-dark-premium pt-[150px] pb-16 lg:pt-[170px]">
        <LightArc />
        <div className="relative max-w-[1400px] mx-auto px-5 lg:px-10">
          <Reveal direction="left">
            <div className="eyebrow text-[#00CFFF] mb-5">About TrustDesk</div>
            <h1 className="font-display font-black text-white text-4xl sm:text-5xl lg:text-[56px] leading-[1.08] tracking-tight max-w-3xl">
              {about.headline || "Skilled people. Real progress."}
            </h1>
          </Reveal>
        </div>
      </section>

      <section
        className="py-20 relative overflow-hidden text-white"
        style={{ backgroundImage: "url(/services-bg.png)", backgroundSize: "cover", backgroundPosition: "center" }}
        data-testid="about-page"
      >
        <div
          aria-hidden="true"
          className="absolute inset-0"
          style={{ backgroundImage: "url(/services-bg.png)", backgroundSize: "cover", backgroundPosition: "center", filter: "blur(22px)", transform: "scale(1.12)" }}
        />
        <div aria-hidden="true" className="absolute inset-0 bg-[rgba(5,13,26,0.74)]" />

        <div className="relative z-10 max-w-[1400px] mx-auto px-5 lg:px-10 grid lg:grid-cols-2 gap-14 items-start">
          <Reveal direction="left">
            <h2 className="font-display font-black text-2xl sm:text-3xl">Our story</h2>
            <div className="mt-5 space-y-4 text-white/85 leading-relaxed whitespace-pre-line">{about.story}</div>
            <h2 className="mt-12 font-display font-black text-2xl sm:text-3xl">The team behind the work</h2>
            <p className="mt-5 text-white/85 leading-relaxed whitespace-pre-line">{about.team_description}</p>
            <div className="mt-10 flex flex-wrap gap-4">
              <a href="/apply" className="btn btn-primary" data-testid="about-apply-button">
                Apply Now <ArrowUpRight size={16} strokeWidth={2.5} />
              </a>
              <button className="btn btn-outline-light" onClick={() => openBooking(null, "booking")} data-testid="about-book-button">
                Book a Free Consultation
              </button>
            </div>
          </Reveal>

          <Reveal direction="right">
            <div className="grid gap-6">
              {(about.images || []).map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt="TrustDesk team"
                  className="w-full h-60 sm:h-72 object-cover rounded-2xl border border-white/10 shadow-[0_24px_60px_rgba(0,0,0,0.45)]"
                  style={{ marginTop: i % 2 === 1 ? 28 : 0 }}
                  loading="lazy"
                />
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      <FooterCta />
      <Footer />
      <ChatBubble />
    </div>
  );
}

export default function AboutUsPage() {
  return (
    <SiteProvider>
      <About />
    </SiteProvider>
  );
}
